const state = {
    user_info: {},
    ablities:null
};

const getters = {
    user(state) {
        return state.user_info;
    },
    currentAbilities(){
        return state.ablities
    },
};

const actions = {
    setUser(context , user){
        context.commit('user', user)
    }
};

const mutations = {
    user(state, user) {
        state.user_info = user;
    },

    setAbilities(state, payload) {
        state.ablities = payload
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
